import { Box, BoxProps, Stack } from '@mantine/core'
import useStyles from './index.styles'

export const EllipseImage = ({
  icon,
  isPink,
  className,
  styles,
  classNames,
  ...boxProps
}: { icon: JSX.Element; isPink?: boolean } & BoxProps) => {
  const { classes, cx } = useStyles(
    { isPink },
    {
      name: 'EllipseImage',
      styles,
      classNames,
    },
  )
  return (
    <Box
      className={cx(className, classes.root)}
      sx={{ position: 'relative' }}
      {...boxProps}
    >
      <Stack className={classes.inner} align="center" justify="center">
        <Box className={classes.wrapper}>{icon}</Box>
      </Stack>
    </Box>
  )
}
